import { useRef } from 'react';

export const useRequestHistory = () => {
  const history = useRef<Record<string, boolean>>({});

  const runRequest = async <T>(name: string, request: () => Promise<T>): Promise<T | undefined> => {
    if (!history.current[name]) {
      const result = await request();
      history.current[name] = true;
      return result;
    }
  };

  return { runRequest };
};
